import { FormControl, FormHelperText, TextField } from '@mui/material';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTime } from 'luxon';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useRouter } from 'next/router';

interface CreditCardExpiryDateInputProps {
  value: string;
  handleChange: (value: DateTime, keyboardInputValue?: string) => void;
  registerFunc: () => object;
  isLoading?: boolean;
  isError?: boolean;
  helperText?: string;
}

export const CreditCardExpiryDateInput: FC<CreditCardExpiryDateInputProps> = ({
  value,
  handleChange,
  registerFunc,
  isLoading = false,
  isError = false,
  helperText = '',
}) => {
  const { locale } = useRouter();
  return (
    <FormControl>
      <DatePicker
        {...registerFunc()}
        label={<FormattedMessage id='my_credit_cards.expiry_date' />}
        disabled={isLoading}
        value={value}
        inputFormat='MM/yy'
        views={['month', 'year']}
        renderInput={params => (
          <TextField
            {...params}
            id='credit-card-expiry-date'
            dir={locale === 'ar' ? 'rtl' : 'ltr'}
            sx={
              isError
                ? { '.MuiSvgIcon-root': { fill: theme => theme.palette.error.main } }
                : {}
            }
            onKeyDown={e => e.preventDefault()}
            error={isError}
            inputProps={{
              ...params.inputProps,
              placeholder: DateTime.now().setLocale(locale).toFormat('MM/yy'),
            }}
          />
        )}
        minDate={DateTime.now()}
        maxDate={DateTime.now().plus({ years: 20 })}
        onChange={handleChange}
      />
      {isError ? <FormHelperText error>{helperText}</FormHelperText> : null}
    </FormControl>
  );
};
